import { graphql } from "../gql";

export const getBatchClaimAuditDocumentationQueryDoc = graphql(`
  query getBatchClaimAuditDocumentation($batchClaimId: UUID!) {
    batchClaim(id: $batchClaimId) {
      __typename
      auditDocumentation {
        __typename
        fileName
        id
        process
        signedUrl
        size
        subFile
        uploadConfirmedAt
      }
      id
    }
  }
`);
